import { Injectable } from '@angular/core';
import { Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import { environment } from '../../../../environments/environment';
import { NotificationBuilder } from '../../models/builders/notification.builder';
import { HttpService } from '../base/http.service';

@Injectable()
export class NotificationHttpService {
  private apiUrl: string;

  constructor(private httpService: HttpService) {
    this.apiUrl = `${environment.apiUrl}notifications`;
  }

  answerNotification(hash: string, answer: boolean) {
    const postBody = { answer };
    return this.httpService.post(`${this.apiUrl}/${hash}/answer`, postBody);
  }

  getNotifications(page: number, count: number, read?: boolean): Observable<any> {
    const params = new URLSearchParams();
    const from = ((page > 0) ? page - 1 : 0) * count;
    params.append('from', from.toString());
    params.append('count', count.toString());
    if (read != null) {
      params.append('read', read.toString());
    }
    const options = new RequestOptions();
    options.params = params;

    return this.httpService.get(this.apiUrl, options)
      .map((response: Response) => response.json())
      .map((data: any) => {
        data.notifications = NotificationBuilder.fromJsonList(data.notifications);
        return data;
      });
  }

  markAsRead(hash: string) {
    const headers = new Headers();
    headers.set('no-blocking', true.toString());
    const options = new RequestOptions();
    options.headers = headers;
    return this.httpService.put(`${this.apiUrl}/${hash}/read`, {}, options);
  }

  markMultipleAsRead(hashes: string[]) {
    const params = new URLSearchParams();
    params.append('notifications', hashes.join(','));
    const options = new RequestOptions();
    options.params = params;
    return this.httpService.put(`${this.apiUrl}/read`, {}, options);
  }
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/api/notification-http.service.ts